// extracted by mini-css-extract-plugin
export default {"ftIcon":"style_ftIcon__rygTi"};